import {
    BusinessProfileDetails,
    businessProfileDisplayName,
    BusinessProfileId,
} from "@sp-crm/core";
import type { BusinessProfileOutput } from "./use-business-verification";

export const businessVerificationPath = "/settings/integrations/business-verification";

export const businessProfilePath = (id: BusinessProfileId): string =>
    `${businessVerificationPath}/${id}`;

export const toBusinessProfileDetails = (
    profile: Pick<BusinessProfileOutput, "details">,
): BusinessProfileDetails => profile.details as BusinessProfileDetails;

export const businessDisplayName = (details: BusinessProfileDetails): string =>
    businessProfileDisplayName(details, "Your business");

const joinNames = (names: string[]): string =>
    names.length <= 1
        ? names.join("")
        : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;

const countOf = (count: number, noun: string): string =>
    `${count} ${noun}${count === 1 ? "" : "s"}`;

export const officesPhrase = (names: string[], otherCount: number): string => {
    if (names.length === 0) {
        return countOf(otherCount, "office");
    }
    const named = `the ${joinNames(names)} ${names.length === 1 ? "office" : "offices"}`;
    return otherCount === 0
        ? named
        : `${named} and ${countOf(otherCount, "other office")}`;
};
